import React from 'react';

import WhoWeAreBox from './WhoWeAreBox';
import './WhoWeAre.css'

class WhoWeAre extends React.Component {
  render() {
    return (
      <div className='row'>
        {this.props.whoWeAreData.map((personInfo, index) => <WhoWeAreBox personInfo={personInfo} key={index}/>)}
        <p className="text-center">Both Erin and Linda bring a proven reputation for truly effective training in a challenging and ever-changing marketplace.</p>
      </div>
    )
  }
}

WhoWeAre.propTypes = {
  whoWeAreData: React.PropTypes.array.isRequired
}

export default WhoWeAre;



// WEBPACK FOOTER //
// ./src/components/WhoWeAre.js